__webpack_require__.p = "/Yugioh/";